import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Badge, Tab } from '@mui/material';
import React, { useEffect } from 'react';
import { useAppSelector } from 'src/store/hooks';
import '../UXPages/tsdaStyles.scss';
import EligiblePatient from './EligiblePaitients';
import InTrailPaitients from './InTrailPaitients';
import PreScreenFail from './PreScreenFail';

const TrailEligiblePatientInfo: React.FunctionComponent<any> = () => {
  const [tabpanelData, setTabpanelData] = React.useState([
    { value: '1', cmp: EligiblePatient, label: 'PATIENTS LISTING FROM EMR' },
    { value: '2', cmp: InTrailPaitients, label: 'IN TRIAL PATIENTS', badge: true, badgeCount: 0 },
    { value: '3', cmp: PreScreenFail, label: 'PRESCREEN FAIL PATIENTS' }
  ]);

  const fromNavigationPathName: any = useAppSelector((state: any) => {
    return state.navigationPath.navigationPathName;
  });

  useEffect(() => {
    if (fromNavigationPathName !== '' && fromNavigationPathName !== null) {
      if (fromNavigationPathName === 'inTrialPatient') {
        setValue('2');
      }
    }
  }, [fromNavigationPathName]);

  // for Tabs
  const [value, setValue] = React.useState('1');
  const handleChangeTabs = (_: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <div>
      <TabContext value={value}>
        <TabList
          onChange={handleChangeTabs}
          aria-label="TSDA Patients Notebook Tabs"
          className="tabsFontSize extendedTabs"
          sx={{ mt: -1.75 }}
        >
          {tabpanelData.map(tabs => (
            <Tab
              label={
                <div>
                  {tabs.badge ? (
                    <Badge badgeContent={tabs.badgeCount} color="primary">
                      {tabs.label}
                    </Badge>
                  ) : (
                    <>{tabs.label}</>
                  )}
                </div>
              }
              value={tabs.value}
              key={tabs.value}
            />
          ))}
        </TabList>
        {tabpanelData.map(tab => (
          <TabPanel value={tab.value} sx={{ p: 0 }} key={tab.value}>
            <tab.cmp setTabpanelData={setTabpanelData} tabpanelData={tabpanelData} setValue={setValue} value={value} />
          </TabPanel>
        ))}
      </TabContext>
    </div>
  );
};

export default React.memo(TrailEligiblePatientInfo);
